export class MockJwtHelperService {
  decodeToken = jasmine.createSpy('decodeToken');
  isTokenExpired = jasmine.createSpy('isTokenExpired');
}
